import React from 'react';
import TextInput from '../../../Shared/TextInput/TextInput';

const PhoneNumbersSection = ({form, formErrors, onPhoneChange}) => (
  <div className='activate-niud-sub-step borderline'>
    <div className='M_Sub_Title'>פרטי ניוד</div>
    <div className='activate-niud-field'>
      <TextInput
        error={formErrors.hostNumber}
        onChange={(e) => onPhoneChange('hostNumber', e)}
        placeholder='מספר מארח'
        name='hostNumber'
        value={form.hostNumber}
        type='text'
        pattern='[0-9]*'
        maxLength='10'
        required='required'
      />
    </div>
    <div className='activate-niud-field'>
      <TextInput
        error={formErrors.niudNumber}
        onChange={(e) => onPhoneChange('niudNumber', e)}
        placeholder='מספר לניוד'
        name='niudNumber'
        value={form.niudNumber}
        type='text'
        pattern='[0-9]*'
        maxLength='10'
        required='required'
      />
    </div>
  </div>
);

export default PhoneNumbersSection;
